import { KeyboardArrowDown } from '@mui/icons-material';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import type { FC } from 'react';
import { usePopover } from 'src/hooks/use-popover';
import { DefaultSkillIcon } from 'src/pages/therapist-dashboard/dashboard-icon';

interface MultiSelectProps {
  label: string;
  onChange?: any;
  options: { label: string; value: unknown; icon: any; id?: string }[];
  selectedValue?: any;
  resetVal?: any;
}

export const SkillsMultiSelect: FC<MultiSelectProps> = (props: any) => {
  const { label, onChange, options, resetVal, selectedValue, ...other } = props;
  const popover = usePopover<HTMLButtonElement>();

  const handleValueChange = (e: any) => {
    if (selectedValue === e) {
      resetVal('');
      popover.handleClose();
      return;
    }
    onChange(e);
    popover.handleClose();
  };

  return (
    <>
      <Button
        sx={{
          fontWeight: '600',
          padding: '0',
          color: '#6C737F',
        }}
        endIcon={<KeyboardArrowDown />}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        {...other}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '13px',
          }}
          noWrap={true}
        >
          {label}
        </Typography>
      </Button>
      <Menu
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
        onChange={handleValueChange}
      >
        {options.map((option: any) => (
          <MenuItem
            key={option.skillName}
            value={option.skillName}
            onClick={() => handleValueChange(option.skillName)}
            sx={{
              background: selectedValue === option.skillName ? ' rgb(128, 128, 128,0.1)' : 'none',
            }}
          >
            {option?.skillImage && option?.skillImage?.endsWith('svg') ? (
              <img
                width="40px"
                height="40px"
                src={option?.skillImage}
                alt="not found"
              />
            ) : (
              <DefaultSkillIcon />
            )}

            <Typography
              sx={{
                color: '#111927',
                fontSize: '12px',
                fontWeight: 400,
              }}
            >
              {option.skillName}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
